import z from 'zod';
import { IDI } from './diInterface';
import { Draft } from '../../common';
import { EmailSchema,E164PhoneSchema} from 'src/types/validation/validators';
import { getAddressSchema } from './../../address';
import { NoForeignValues } from '../orgSchema';

  const contactSchema = z.object({
    name: NoForeignValues(z.string().min(1).max(150)),
    title: NoForeignValues(z.string().min(1).max(40)),
    phone: E164PhoneSchema,
    email: EmailSchema
  });

const diBaseSchema = z.object({
  apEligibilityInd: z.boolean(),
  satEligibilityInd: z.boolean()
  //clepEligibilityInd: z.boolean()
});

export const getSchema = (diData: Draft<IDI>) => {
  const {apAddress} = diData;
  const ApAddressSchema = getAddressSchema(apAddress?.countryIsoCd);
  //const ClepAddressSchema = getAddressSchema(clepAddress?.countryIsoCd);

  return diBaseSchema.extend({
      diCode: z.string().optional(),
      apContact : diData.apEligibilityInd ? contactSchema : contactSchema.optional(),
      satContact : diData.satEligibilityInd ? contactSchema : contactSchema.optional(),
      //clepContact : diData.clepEligibilityInd ? contactInfoSchema.getSchema() : contactSchema.optional(),
      apAddress:   ApAddressSchema.optional().nullable(), //can be null or undefined
      //clepAddress: clepAddress ?  ClepAddressSchema : ClepAddressSchema.optional(),
      diMergedCode: z.string().optional()
  });
}